import { Helper } from "./helper";

interface InvalidCondition {
  [condition: string]: {
    matcher: RegExp;
    handler: (url: string) => string;
  };
}

/**
 * The order of these conditions matters.
 * Since each condition handler will modify the original value,
 * the order should be set so that subsequent handlers do not
 * make an invalid url for the previous conditions.
 */
export const invalidConditions: InvalidCondition = {
  commas: {
    // eg test,test
    matcher: new RegExp(`,`),
    handler: (url: string): string => Helper.removePortionFromString(url, new RegExp(`,`, "g"), "-"),
  },

  consecutiveHyphens: {
    // eg test-----
    matcher: new RegExp(`--`),
    handler: (url: string): string => Helper.removeExtraConsecutiveCharactersFromString(url, "-"),
  },

  leadingHyphen: {
    // eg /-test
    matcher: new RegExp(`\/-`),
    handler: (url: string): string => Helper.removePortionFromString(url, new RegExp(`\/-`, "g"), "/"),
  },
};
